<template>
  <b-modal
    size="lg"
    id="modal-notification"
    centered
    :title="`Notification ${notifType}`"
    hide-footer
    @show="onModalShow"
    @hide="closeNotification"
  >
    <div class="notification-content mt-2" v-show="submitLoading">
      <div class="d-flex justify-content-center">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
        <span class="ml-2">Sending notification, please wait...</span>
      </div>
    </div>
    <div class="notification-content mt-2" v-show="!submitLoading">
      <label for="email-to"
        >Recipients <span class="text-danger">*</span></label
      >
      <div class="card p-3">
        <div class="row">
          <div class="col-12 col-md-6">
            <div
              class="row"
              v-if="type == 'acknowledge' || type == 'response acknowledge'"
            >
              <div class="col-12 col-md-12">
                <label for="email-to">Requestor</label>
                <v-select
                  ref="ref_emailsRequestor"
                  v-model="payload.emailsRequestor"
                  placeholder="Type email then press enter to add"
                  multiple
                  taggable
                  no-drop
                  :select-on-key-codes="[188, 13]"
                  :select-on-tab="true"
                  @search:blur="addEmail('emailsRequestor')"
                ></v-select>
              </div>
              <div class="col-12 col-md-12 my-4">
                <label for="email-to">Genta Gendis</label>
                <v-select
                  ref="ref_emailsGG"
                  v-model="payload.emailsGG"
                  placeholder="Type email then press enter to add"
                  multiple
                  taggable
                  no-drop
                  :select-on-key-codes="[188, 13]"
                  :select-on-tab="true"
                  @search:blur="addEmail('emailsGG')"
                ></v-select>
              </div>
            </div>
            <div class="row" v-else>
              <div class="col-12 col-md-12">
                <label for="email-to">Email</label>
                <v-select
                  ref="ref_emails"
                  v-model="payload.emails"
                  placeholder="Type email then press enter to add"
                  multiple
                  taggable
                  no-drop
                  :select-on-key-codes="[188, 13]"
                  :select-on-tab="true"
                  @search:blur="addEmail('emails')"
                ></v-select>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6" v-if="type == 'acknowledge'">
            <label for="email-to"
              >Email Cc
              <span class="text-secondary">(Demand Touchpoint)</span></label
            >
            <v-select
              ref="ref_emailCc"
              v-model="payload.emailCc"
              placeholder="Type email then press enter to add"
              multiple
              taggable
              no-drop
              :select-on-key-codes="[188, 13]"
              :select-on-tab="true"
              @search:blur="addEmail('emailCc')"
            ></v-select>
          </div>
        </div>
      </div>
      <div class="card p-3">
        <div class="row">
          <div class="col-12 mt-2">
            <label for="invitation-meet"
              >Email Subject <span class="text-danger">*</span></label
            >
            <input
              type="text"
              class="form-control"
              v-model="payload.subject"
              name="subject"
              placeholder="Subject"
              v-validate="'required'"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12 mt-4">
            <div class="form-group">
              <label>Email Body <span class="text-danger">*</span></label>
              <vue-editor
                :value="payload.message"
                @input="payload.message = $event"
                v-validate="'required'"
                name="Email Body"
                ref="quillEditor"
              />
              <span
                class="text-sm text-danger"
                v-show="errors.has('Email Body')"
                >{{ errors.first("Email Body") }}</span
              >
            </div>
          </div>
        </div>
        <div class="row" v-if="type == 'acknowledge'">
          <div class="col-12 mt-2">
            <label for="invitation-meet"
              >Invitation Meet <span class="text-danger">*</span></label
            >
            <datetime
              v-model="invitationDate"
              v-validate="'required'"
              name="invitationDate"
              type="datetime"
              input-class="form-control"
              placeholder="YYYY-MM-DD HH:mm"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('invitationDate')"
            >
              Invitation Meet is required
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end" v-if="!submitLoading">
      <button class="btn btn-outline-secondary" @click="closeConfirmModal">
        Cancel
      </button>
      <button
        class="btn btn-primary ml-2"
        @click="sendConfirmation"
        :disabled="submitLoading"
      >
        Send
      </button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "ModalNotification",
  props: {
    type: String,
    notifType: String,
    recipientsRequestor: Array,
    recipientsGG: Array,
    cc: Array,
    ideationId: Number,
    ideationName: String,
    ideationDate: String,
    userName: String,
    userRole: String,
  },
  data() {
    return {
      payload: {
        ideationId: null,
        emailCc: [],
        emails: [],
        emailsRequestor: [],
        emailsGG: [],
        attachments: [],
        subject: "",
        message: "",
        type: "",
      },
      defaultEmails: [],
      invitationDate: "",
      uploading: false,
      uploadingProgress: 0,
      submitLoading: false,
    };
  },
  computed: {
    templateSubject() {
      let subject = ``;
      if (this.type === "acknowledge") {
        subject = `Uideation - Acknowledge Ideation ${this.ideationName} by Demand Touchpoint`;
      } else if (this.type === "fu acknowledge") {
        subject = `Uideation - Follow Up Acknowledge Ideation ${this.ideationName}`;
      } else if (this.type === "response acknowledge") {
        subject = `Uideation - Response Acknowledge Ideation ${this.ideationName}`;
      }
      return subject;
    },
    templateMessage() {
      if (this.type === "acknowledge") {
        let today = new Date().toISOString().slice(0, 10);

        let invitation = {
          date: "[ AKAN DIREPLACE DARI INPUTAN DIBAWAH ]",
          time: "[ AKAN DIREPLACE DARI INPUTAN DIBAWAH ]",
        };
        if (this.invitationDate) {
          invitation = this.formatDateTime(this.invitationDate);
        }

        return `<p><strong>Dear Bapak/Ibu,</strong></p><p>Sehubungan dengan Ideation <em>${
          this.ideationName
        }</em> yang telah bapak/ibu submit di <strong>Uideation</strong> pada <strong>${this.formatDateTimeMonthName(
          this.ideationDate
        )}</strong>, Ideation bapak/ibu telah kami terima dan pahami pada <strong>${this.formatDateTimeMonthName(
          today
        )}</strong>.</p><p>Untuk menindaklanjuti ideation tersebut, kami mengundang Bapak/Ibu untuk menghadiri meeting pada : </p><p>📅 <strong>Tanggal:</strong> ${
          invitation.date
        }</p><p>🕒 <strong>Waktu:</strong> ${invitation.time}</p>`;
      } else if (this.type === "fu acknowledge") {
        return `<p><strong>Dear Bapak/Ibu Demand Touchpoint,</strong></p><br><p>Terkait ideation <em>${
          this.ideationName
        }</em> yang sudah disubmit pada tanggal <strong>${this.formatDateTimeMonthName(
          this.ideationDate
        )}</strong>, saya ingin menanyakan tindak lanjut atau perkembangan terbaru dari ideation tersebut.</p><br><p style="font-size: 16px; line-height: 1;"><strong>Salam,</strong></p><p style="font-size: 16px; line-height: 1;">${
          this.userName
        } - ${this.userRole}</p>`;
      } else if (this.type === "response acknowledge") {
        return `<p><strong>Dear Bapak/Ibu,</strong></p><br><p>Terkait ideation <em>${this.ideationName}</em> sedang kami lakukan review bersama, dan akan kami informasikan kembali segera.</p><br><p style="font-size: 16px; line-height: 1;"><strong>Salam,</strong></p><p style="font-size: 16px; line-height: 1;">Demand Touchpoint</p>`;
      } else {
        return ``;
      }
    },
  },
  watch: {
    invitationDate(newVal) {
      this.payload.message = this.templateMessage;
    },
  },
  methods: {
    addEmail(input) {
      if (input == "emailsRequestor") {
        let inputValue = this.$refs.ref_emailsRequestor.search;
        if (inputValue && !this.payload.emailsRequestor.includes(inputValue)) {
          this.payload.emailsRequestor.push(inputValue);
        }
        this.$refs.ref_emailsRequestor.search = "";
      } else if (input == "emailsGG") {
        let inputValue = this.$refs.ref_emailsGG.search;
        if (inputValue && !this.payload.emailsGG.includes(inputValue)) {
          this.payload.emailsGG.push(inputValue);
        }
        this.$refs.ref_emailsGG.search = "";
      } else if (input == "emails") {
        let inputValue = this.$refs.ref_emails.search;
        if (inputValue && !this.payload.emails.includes(inputValue)) {
          this.payload.emails.push(inputValue);
        }
        this.$refs.ref_emails.search = "";
      } else {
        let inputValue = this.$refs.ref_emailCc.search;
        if (inputValue && !this.payload.emailCc.includes(inputValue)) {
          this.payload.emailCc.push(inputValue);
        }
        this.$refs.ref_emailCc.search = "";
      }
    },
    // validateAttachments(event) {
    //   const files = event.target.files;
    //   const maxSize = 10 * 1024 * 1024;
    //   const allowedTypes = [
    //     "application/pdf",
    //     "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    //     "application/msword",
    //     "application/vnd.ms-excel",
    //   ];

    //   if (files.length < 1) return false;

    //   for (let i = 0; i < files.length; i++) {
    //     const file = files[i];
    //     if (file && file.size > maxSize) {
    //       this.$swal({
    //         title: "Error",
    //         text: "File size exceeds 10MB. Please upload a smaller file.",
    //         icon: "error",
    //         confirmButtonText: "OK",
    //       });
    //       event.target.value = "";
    //       return;
    //     }
    //     if (file && !allowedTypes.includes(file.type)) {
    //       this.$swal({
    //         title: "Error",
    //         text: "Only PDF, DOCX, XLSX, DOC, XLS files are allowed.",
    //         icon: "error",
    //         confirmButtonText: "OK",
    //       });
    //       event.target.value = "";
    //       return;
    //     }
    //   }
    //   return true;
    // },

    formatDateTime(date) {
      if (!date) return "";
      const d = typeof date === "string" ? new Date(date) : date;

      const pad = (n) => (n < 10 ? "0" + n : n);
      const yyyy = d.getFullYear();
      const mm = pad(d.getMonth() + 1);
      const dd = pad(d.getDate());
      const hh = pad(d.getHours());
      const mi = pad(d.getMinutes());

      const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
      ];
      const month = months[d.getMonth()];

      return {
        date: `${dd} ${month} ${yyyy}`,
        time: `${hh}:${mi} WIB`,
      };
    },

    formatDateTimeMonthName(data) {
      const date = new Date(data);
      const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
      ];
      const day = date.getDate();
      const month = months[date.getMonth()];
      const year = date.getFullYear();

      return `${day} ${month} ${year}`;
    },

    // async setFileAttachments(event) {
    //   const validate = this.validateAttachments(event);
    //   if (!validate) return;

    //   const payload = {
    //     department: this.selectedDepartment,
    //     attachments: [...event.target.files],
    //   };

    //   this.uploading = true;

    //   // animate loading progress
    //   let progress = 0;
    //   const duration = 3000;
    //   const start = performance.now();
    //   const interval = setInterval(() => {
    //     const timeElapsed = performance.now() - start;
    //     const progress = Math.min((timeElapsed / duration) * 100, 100);
    //     this.uploadingProgress = progress;
    //     if (progress >= 100) clearInterval(interval);
    //   }, 10);
    //   await this.uploadFiles(payload).finally(() => {
    //     this.uploading = false;
    //     this.uploadingProgress = 0;
    //   });
    // },

    // async uploadFiles(payload) {
    //   console.log("-files-", payload);
    //   try {
    //     const uploadedFiles = await this.$store.dispatch(
    //       "budgetPlan/UPLOAD_DOCUMENT",
    //       payload
    //     );
    //     this.payload.attachments = uploadedFiles;
    //   } catch (error) {
    //     console.error(error);
    //     this.$swal({
    //       title: "Error",
    //       text: "An error occurred while uploading files.",
    //       icon: "error",
    //       confirmButtonText: "OK",
    //     });
    //   }
    // },

    async setRecipients() {
      if (this.type === "acknowledge") {
        this.payload.emailsRequestor = Array.from(
          new Set(this.recipientsRequestor)
        );
        this.payload.emailsGG = Array.from(new Set(this.recipientsGG));
        this.payload.emailCc = Array.from(new Set(this.cc));
      } else if (this.type === "fu acknowledge") {
        this.payload.emails = Array.from(new Set(this.cc));
      } else if (this.type === "response acknowledge") {
        console.log("this.recipientsRequestor ===> ", this.recipientsRequestor);
        console.log("this.recipientsGG ===> ", this.recipientsGG);
        this.payload.emailsRequestor = Array.from(
          new Set(this.recipientsRequestor)
        );
        this.payload.emailsGG = Array.from(new Set(this.recipientsGG));
      }
    },

    onModalShow() {
      this.payload.ideationId = this.ideationId;
      this.payload.subject = this.templateSubject;
      this.payload.type = this.type;
      this.setRecipients();
      this.$nextTick(() => {
        this.payload.message = this.templateMessage;
      });
    },

    closeNotification(evt) {
      if (evt.trigger === "backdrop") {
        evt.preventDefault();
      }
      if (evt.trigger === "headerclose") {
        evt.preventDefault();
        this.closeConfirmModal();
      }
    },

    resetPayload() {
      this.payload = {
        emailCc: [],
        emails: [],
        emailsRequestor: [],
        emailsGG: [],
        // attachments: [],
        message: "",
        type: "",
      };
      //   this.uploadedFiles = [];
      //   this.$refs.file_attachments.value = null;
    },

    closeConfirmModal(evt) {
      this.$swal({
        title: "Are you sure ?",
        text: "This notification will be canceled",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: `Yes, i'm sure!`,
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          this.resetPayload();
          this.$emit("hide-modal");
        }
      });
    },

    sendConfirmation() {
      const sendingNotification = async () => {
        const allEmails = [
          ...this.payload.emails,
          ...this.payload.emailsGG,
          ...this.payload.emailsRequestor,
        ];

        const uniqueEmails = [...new Set(allEmails)];

        const payload = {
          ideationId: this.payload.ideationId,
          attachments: this.payload.attachments,
          emailCc: this.payload.emailCc,
          emails: uniqueEmails,
          message: this.payload.message,
          subject: this.payload.subject,
          type: this.payload.type,
        };
        await this.$store.dispatch(
          "ideation/SEND_ACKNOWLEDGE_DEMANDTOUCHPOINT",
          payload
        );
      };

      if (
        this.payload.emailCc.length === 0 &&
        this.payload.emails.length === 0 &&
        this.payload.emailsGG.length === 0 &&
        this.payload.emailsRequestor.length === 0
      ) {
        this.$swal({
          title: "Warning",
          text: "Recipients must be filled in at least 1 email",
          icon: "warning",
          confirmButtonText: "ok",
        });
      } else {
        this.$validator.validateAll().then((valid) => {
          if (valid) {
            this.$swal({
              title: "Are you sure ?",
              text: "Notification will be sent to all recipients added",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#00D97E",
              cancelButtonColor: "#E63757",
              confirmButtonText: `Yes, i'm sure!`,
              cancelButtonText: "Cancel",
            })
              .then(async (result) => {
                if (result.isConfirmed) {
                  this.submitLoading = true;
                  await sendingNotification().then(async () => {
                    this.resetPayload();
                    this.$swal({
                      title: "Success",
                      text: "Notification has been sent successfully",
                      icon: "success",
                      confirmButtonText: "OK",
                    });
                    this.$emit("hide-modal");
                    this.submitLoading = false;
                  });
                }
              })
              .catch((error) => {
                console.error("Error sending notification:", error);
                this.$swal({
                  title: "Error",
                  text: "Failed to send notification",
                  icon: "error",
                  confirmButtonText: "OK",
                });
                this.submitLoading = false;
              });
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.notification-content {
  /* Add your styling for the notification content here */
}
</style>
